import PropTypes from "prop-types";
import React from "react";
import { getRehydratableName, getClassNameFactory } from "../../../../../../utilities";
import classNames from "classnames";

var Chapter = function Chapter(_ref) {
  var active = _ref.active,
      href = _ref.href,
      prefix = _ref.prefix,
      title = _ref.title;
  var getClassName = getClassNameFactory("LongformChapterNavChapter");
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      states: classNames({
        active: active
      })
    }),
    "data-active": active ? JSON.stringify(active) : null,
    "data-href": JSON.stringify(href),
    "data-prefix": prefix ? JSON.stringify(prefix) : null,
    "data-title": JSON.stringify(title),
    "data-rehydratable": getRehydratableName(Chapter.displayName)
  }, /*#__PURE__*/React.createElement("a", {
    className: getClassName({
      descendantName: "inner"
    }),
    href: href
  }, prefix ? /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "prefix",
      utilities: "typographySmallCaps"
    })
  }, prefix) : null, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "title"
    })
  }, title)));
};

Chapter.displayName = "Longform.ChapterNav.Chapter";
Chapter.propTypes = {
  /**
   * Set this chapter to active. Use for setting the default chapter, or defining the current chapter if not using ChapterNav's `spy` functionality. Will be overwritten when using `spy`.
   */
  active: PropTypes.bool,

  /**
   * URL for the chapter. Should be an anchor if using ChapterNav on a single page (such as with `spy`) or a URL if not. If using on multiple pages, you will need to set the `active` Chapter manually.
   */
  href: PropTypes.string.isRequired,

  /**
   * Prefix for the chapter, such as "1.". Numbers work better than the longhand.
   */
  prefix: PropTypes.string,

  /**
   * Title of the chapter.
   */
  title: PropTypes.string.isRequired
};
export default Chapter;